// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect } from 'react';

import { isNil, isNotNil } from 'helpers/isNotNil';
import { TaskAdder } from 'modules/Shop/ShopSetup/WorkCellSetup/ShopSetupPage/TaskTypes/TaskAdder';

import { useWorkCellSetup } from '../WorkCellSetupContext';
import { MapTaskToWorkCellPopover } from './MapTaskToWorkCellPopover';
import { useTaskTypes } from './useTaskTypes';

export const WorkCellTaskAdder = () => {
  const { draftShopConfiguration, loadingDraftShopConfiguration, activeShopConfiguration } = useWorkCellSetup();

  const { setHideSelect, setShopConfiguration } = useTaskTypes();

  useEffect(() => {
    setHideSelect(isNil(draftShopConfiguration));
  }, [draftShopConfiguration, setHideSelect]);

  useEffect(() => {
    setShopConfiguration(draftShopConfiguration ?? activeShopConfiguration);
  }, [activeShopConfiguration, draftShopConfiguration, setShopConfiguration]);

  if (loadingDraftShopConfiguration) return null;

  return (
    <TaskAdder
      withHeader
      isWorkCellMapping
      rightSideComponent={(selectedTasks, selectedGroups, reset) =>
        isNotNil(draftShopConfiguration) && (
          <MapTaskToWorkCellPopover
            onComplete={() => reset(true)}
            taskTypes={selectedTasks}
            taskTypeGroups={selectedGroups}
          />
        )
      }
    />
  );
};
